function initialState() {
  return {
    loadingAutoDj: null,

    autoDj: {
      playlist: [],
      shuffle: false,
      options: {
        adsFrequency: 0,
        adsDuration: 0
      },
      stream: "",
      modified: 0
    },

    current: {
      onAir: null,
      stream: "",
      track: ""
    },
  }
}

let state = initialState()

export {
  initialState,
  state
}
